// extracted by mini-css-extract-plugin
export default {"bg-primary-dark":"AddStepButton_bg-primary-dark__LyrPx","bg-primary-light":"AddStepButton_bg-primary-light__W3Mgx","root":"AddStepButton_root__hhEFI"};